export default "__VITE_PUBLIC_ASSET__69c1b71b__"